import { Alert } from '@octano/global-ui';

import {
  DegreeProcessActivity,
  DegreeProcessDocument,
  DegreeProcessSummary,
  TitulationPaymentInfo,
} from '../types';
import { DegreeDocumentsSection } from './DegreeDocumentsSection';
import FormView from './FormView';
import Table from './Table';
import { TitulationPaymentSection } from './TitulationPaymentSection';
export interface DegreeProcessProps {
  studyPlanEnrollmentId: number;
  summary?: DegreeProcessSummary;
  activities: DegreeProcessActivity[];
  documents?: DegreeProcessDocument[];
  titulationPaymentInfo: TitulationPaymentInfo | null;
  texts: { noActivities: string; titulationPayment: any };
  onRefresh?: () => void;
}

export default function DegreeProcess({
  studyPlanEnrollmentId,
  summary,
  activities,
  documents,
  titulationPaymentInfo,
  texts,
  onRefresh,
}: DegreeProcessProps) {
  return (
    <>
      <div className="mb-4">
        {Boolean(activities.length) && (
          <>
            <p className="text-right">
              Las siglas N/A significan que no aplica nota
            </p>
            <Table data={activities} />
          </>
        )}
        {!activities.length && (
          <Alert
            className=""
            color="info"
            icon="information"
            size="lg"
            text={texts.noActivities}
          />
        )}
      </div>
      {!!documents?.length && (
        <DegreeDocumentsSection
          studyPlanEnrollmentId={studyPlanEnrollmentId}
          documents={documents}
          onRefresh={onRefresh}
        />
      )}
      {titulationPaymentInfo && (
        <TitulationPaymentSection
          titulationPaymentInfo={titulationPaymentInfo}
          texts={texts.titulationPayment}
        />
      )}
      {!!summary && (
        <FormView
          date={summary.date}
          createdAt={summary.createdAt}
          graduationGrade={summary.gradeGraduation}
          degreeGrade={summary.gradeDegreeProcess}
          distinctionRank={summary.distinctionRanks
            ?.map((d) => d.name)
            .join(', ')}
          registerCode={summary.registerCode}
          certificateNumber={summary.certificateNumber}
          registryBook={summary.registryBook}
        />
      )}
    </>
  );
}
